import React from 'react';
import PropTypes from 'prop-types';

import NumberOrTimeInput from './NumberOrTimeInput';
import NumberOrTimePlusInput from './NumberOrTimePlusInput';
import WageInput from './WageInput';
import {
  checkIfTouchedValue,
  isTimeFormula,
  floatToTime,
  timeToFloat,
  splitAmountAndWage,
  findChanges,
  NUMBER_OR_TIME_REGEX
} from './utilities';

class PlusInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isTimeFormat: false,
      hasUpdatedOnce: false
    };
  }

  componentDidUpdate() {
    const { userPayrolls, inputType } = this.props;

    if (this.props.useTimeFormat && userPayrolls.length > 0 && !this.state.hasUpdatedOnce) {
      const isTimeFormat = userPayrolls.some((userPayroll) => isTimeFormula(userPayroll[`${inputType}s`]));

      this.setState({ isTimeFormat: isTimeFormat, hasUpdatedOnce: true });
    }
  }

  convertTimeData = () => {
    const { userPayrolls, inputType, setValueChanged } = this.props;
    const user_payrolls_tmp = JSON.parse(JSON.stringify(userPayrolls));
    let changes = [];

    this.setState({ isTimeFormat: !this.state.isTimeFormat }, () =>{
      user_payrolls_tmp.map((up, index) => {
        switch (inputType) {
        case 'puPlus0': {
          if (NUMBER_OR_TIME_REGEX.test(up['puPlus0s'])) {
            const { wage, amount } = splitAmountAndWage(up['puPlus0s']);
            const formattedAmount = isTimeFormula(up['puPlus0s']) ? timeToFloat(amount) : floatToTime(amount);

            up['puPlus0s'] = `${wage}*${formattedAmount}`;
            up['puPlus0Amount'] = formattedAmount;
          }
          break;
        }
        case 'puPlus1': {
          if (NUMBER_OR_TIME_REGEX.test(up['puPlus1s'])) {
            const { wage, amount } = splitAmountAndWage(up['puPlus1s']);
            const formattedAmount = isTimeFormula(up['puPlus1s']) ? timeToFloat(amount) : floatToTime(amount);

            up['puPlus1s'] = `${wage}*${formattedAmount}`;
            up['puPlus1Amount'] = formattedAmount;
          }
          break;
        }
        case 'puPlus3': {
          if (NUMBER_OR_TIME_REGEX.test(up['puPlus3s'])) {
            const { wage, amount } = splitAmountAndWage(up['puPlus3s']);
            const formattedAmount = isTimeFormula(up['puPlus3s']) ? timeToFloat(amount) : floatToTime(amount);

            up['puPlus3s'] = `${wage}*${formattedAmount}`;
            up['puPlus3Amount'] = formattedAmount;
          }
          break;
        }
        default: break;
        }

        changes = [...changes, ...findChanges(up.uID, up, userPayrolls[index])];
      });

      setValueChanged(changes, user_payrolls_tmp);
    });
  };

  render() {
    const { title,
      inputType,
      puPlusDisplay,
      imageTimerUrl,
      userPayrolls,
      toggleTimer,
      onPlusChange,
      onPlusFocus,
      onWageChange,
      onWageFocus,
      clearAmount,
      onAmountChange,
      onAmountFocus,
      touched,
      useTimeFormat,
      onImeWarning,
    } = this.props;

    return (
      <>
        <tr>
          <th className="item th2">
            <div className="wageTimerWrapper">
              <span>{title}</span>
              <button className={`btn ${inputType}_hour_wage btn-sm wageTimer ${puPlusDisplay && 'btn-success'}`}
                data-bs-toggle="tooltip" onClick={toggleTimer}
                title="時給&#013;日給"
              >
                <img alt="時" src={imageTimerUrl} />
              </button>
            </div>
          </th>
          {userPayrolls.map((userPayroll, index) => {
            return (
              <td className="salary w9" key={index}>
                <NumberOrTimePlusInput
                  className={`inputNumber w9 ${checkIfTouchedValue(touched, userPayroll.uID, `${inputType}s`) ? 'updated' : ''}`} data-column={inputType}
                  data-uid={userPayroll.uID}
                  inputType={inputType}
                  isTimeFormat={this.state.isTimeFormat}
                  name={`payment[${userPayroll.uID}][${inputType}s]`}
                  onChange={(e) => onPlusChange(e, index, `${inputType}s`)}
                  onFocus={(e) => onPlusFocus(e, userPayroll.uID, inputType)}
                  onImeWarning={onImeWarning}
                  type="text"
                  useTimeFormat={useTimeFormat}
                  value={userPayroll[`${inputType}s`] || ''}
                />
              </td>
            );
          })}
        </tr>
        {puPlusDisplay &&
        <>
          <tr>
            <th className="item th2 wage"><span>┣ 時給/日給</span></th>
            {userPayrolls.map((userPayroll, index) => {
              return (
                <td className="salary w9" key={`${inputType}Wage_${index}`}>
                  <WageInput
                    dataUid={userPayroll.uID}
                    name={`payment[${userPayroll.uID}][${inputType}Wage]`}
                    onChange={(e) => onWageChange(e, index, `${inputType}Wage`)}
                    onFocus={(e) => onWageFocus(e, userPayroll.uID, `${inputType}Wage`)}
                    value={userPayroll[`${inputType}Wage`] || ''}
                  />
                </td>
              );
            })}
          </tr>
          <tr className="wage">
            <th className="item th2 wage">
              <span>┗ 時/日数 </span>
              <div className="tools-box">
                { this.props.useTimeFormat &&
                  <button
                    className={`btn btn-sm badge hover-badge convert-${inputType}-amounts`}
                    onClick={() => this.convertTimeData()}
                  >
                    {this.state.isTimeFormat ? '時間' : '数' }
                  </button>
                }
                <a className={`badge badge-mini hover-badge wageClear t_wageClear_${inputType}`} data-bs-toggle="tooltip" href="#" onClick={(e) => { e.preventDefault(); e.stopPropagation(); clearAmount(); }} title="時間数/日数をクリア">X</a>
              </div>
            </th>
            {userPayrolls?.map((userPayroll, index) => {
              return (
                <td className="salary w9" key={`${inputType}_Amount_${index}`}>
                  <NumberOrTimeInput
                    className="inputNumber w9 amount"
                    data-uid={userPayroll.uID}
                    inputType={inputType}
                    isTimeFormat={this.state.isTimeFormat}
                    name={`payment[${userPayroll.uID}][${inputType}Amount]`}
                    onChange={(e) => onAmountChange(e, index, `${inputType}Amount`)}
                    onFocus={(e) => onAmountFocus(e, userPayroll.uID, `${inputType}Amount`)}
                    type="text" value={userPayroll[`${inputType}Amount`] || ''}
                  />
                </td>
              );
            })}
          </tr>
        </>
        }
      </>
    );
  }
}

PlusInput.defaultProps = {
  useTimeFormat: false
};

PlusInput.propTypes = {
  title: PropTypes.string.isRequired,
  inputType: PropTypes.string.isRequired,
  touched: PropTypes.array.isRequired,
  puPlusDisplay: PropTypes.bool.isRequired,
  imageTimerUrl: PropTypes.string.isRequired,
  userPayrolls: PropTypes.array.isRequired,
  toggleTimer: PropTypes.func.isRequired,
  onPlusChange: PropTypes.func.isRequired,
  onPlusFocus: PropTypes.func.isRequired,
  onWageChange: PropTypes.func.isRequired,
  onWageFocus: PropTypes.func.isRequired,
  clearAmount: PropTypes.func.isRequired,
  setValueChanged: PropTypes.func.isRequired,
  onAmountChange: PropTypes.func.isRequired,
  onAmountFocus: PropTypes.func.isRequired,
  useTimeFormat: PropTypes.bool.isRequired,
  onImeWarning: PropTypes.func,
};

export default PlusInput;
